export default __webpack_public_path__ + "static/media/side4.d42bf636.svg";